import { atom } from "jotai";

export type State = {
  reduceWidgetCount: boolean;
  sectionPremiumNativeAdEnable: boolean;
};

export const defaultSectionAtom = atom<State>({
  reduceWidgetCount: false,
  sectionPremiumNativeAdEnable: false,
});
